<script setup lang="ts">
  import { Menu as AppMenu, MenuButton, MenuItems } from '@headlessui/vue'

  defineProps<{
    left?: boolean,
    right?: boolean,
    center?: boolean,
    top?: boolean,
    bottom?: boolean,
    disabled?: boolean,
  }>()
</script>

<template>
  <app-menu
    v-slot="{ open }"
    as="div"
    class="relative"
    :class="{ 'flex justify-center': center }">
    <menu-button title="Klik untuk menampilkan menu">
      <slot :open="open"></slot>
    </menu-button>

    <transition name="scale">
      <menu-items
        class="absolute z-20 overflow-hidden card max-xl:text-sm focus:outline-none"
        :class="{
          'left-0': left,
          'right-0 text-right': right,
          'bottom-full mb-2': top,
          'top-full mt-2': bottom ?? true,
        }">
        <slot name="items"></slot>
      </menu-items>
    </transition>
  </app-menu>
</template>
